import { BlockEmbed } from 'quill/blots/block';

class HorizontalRule extends BlockEmbed {
  static create(value: unknown) {
    const node = super.create(value) as HTMLHRElement;
    // @ts-expect-error Fix next time editing the file
    node.setAttribute('contenteditable', false);
    return node;
  }
}
HorizontalRule.blotName = 'hr';
HorizontalRule.tagName = 'hr';

export default HorizontalRule;
